import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface TablePaginationProps {
  currentPage: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
}

const TablePagination: React.FC<TablePaginationProps> = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
}) => (
  <Box sx={{
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2,
    position: 'sticky', bottom: 0, zIndex: 10,
    backgroundColor: 'background.paper',
    borderTop: '1px solid', borderColor: 'divider',
    py: 1.5,
  }}>
    <Button
      variant="contained"
      onClick={onPrevious}
      disabled={currentPage <= 1}
      sx={{
        bgcolor: 'grey.300',
        color: 'text.primary',
        boxShadow: 'none',
        borderRadius: 2,
        '&:hover': { bgcolor: 'grey.400', boxShadow: 'none' },
        '&:disabled': { bgcolor: 'grey.200', color: 'text.disabled' },
      }}
    >
      Previous
    </Button>
    <Typography variant="body2" color="text.secondary">
      Page {currentPage} of {totalPages}
    </Typography>
    <Button
      variant="contained"
      onClick={onNext}
      disabled={currentPage >= totalPages}
      sx={{
        bgcolor: 'grey.300',
        color: 'text.primary',
        boxShadow: 'none',
        borderRadius: 2,
        '&:hover': { bgcolor: 'grey.400', boxShadow: 'none' },
        '&:disabled': { bgcolor: 'grey.200', color: 'text.disabled' },
      }}
    >
      Next
    </Button>
  </Box>
);

export default TablePagination;
